<template>
  <v-app>

    <Navigation title="Fehlbestände"></Navigation>

    <v-content app>
        <v-container fluid>
      <v-row>
        <v-col v-if="missingCounts.length <= 0" cols="12" sm="12">
            <v-card class="elevation-0">
                <v-alert height="60vh" class=" d-flex justify-center" elevation="0">Keine Fehlbestände bekannt.</v-alert>
            </v-card>
        </v-col>
      </v-row>
    </v-container>
    </v-content>

    <BottomNavigation></BottomNavigation>
  </v-app>
</template>

<script>
import Navigation from "../components/Navigation";
import BottomNavigation from "../components/BottomNavigation";
import { mapState } from "vuex";
import picklistService from '../services/picklistService';

export default {
  name: "MissingCounts",
  components: {
    Navigation,
    BottomNavigation
  },
  computed: mapState({
    missingCounts: state => state.missingCounts,
  }),
};
</script>

<style scoped></style>